import React from "react";
import FigmaBadge from "../Elements/FigmaBadge";
import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import dateTimeHelper from "../Helpers/datetimeHelper";
import stringHelper from "../Helpers/stringHelper";

export default class UninvoiceableAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = "";
      this.AsSassieAsgnId = "";
      this.CuName = "";
      this.AsFee = "";
      this.AsRcysymbol = "";
      this.AsIeFeeAdjustment = "";
      this.AsReimbursement = "";
      this.ReimbursementCurrencySymbol = "";
      this.AsTravel = "";
      this.AsGaming = "";
      this.AsMisc = "";
      this.AsLdvname = "";
      this.AsFieldworkFee = "";
      this.AsEvname = "";
      this.LgsDesc = "";
      this.AsEvaluatorCompletedDate = "";
      this.CuCountry = "";
      this.AsFeeWithSymbol = "";
      this.AsEvaluatorCompletedDateFormatted = "";
      this.AsFeeAdditWithSymbol = "";
      this.AsReimbursementWithSymbol = "";
      this.AsTravelWithSymbol = "";
      this.AsGamingWithSymbol = "";
      this.AsMiscWithSymbol = "";
      this.AsFieldworkFeeWithSymbol = "";
      this.AsUninvoiceable = "";
      this.FeeTotal = "";
      this.ReimbTotal = "";
      this.AsCfname = "";
      this.AsCfid = "";
      this.Selected = false;
    } else {
      this.AsId = item.asId;
      this.AsSassieAsgnId = item.asSassieAsgnId;
      this.CuName = item.cuName;
      this.AsFee = item.asFee;
      this.AsRcysymbol = item.asRcysymbol;
      this.AsIeFeeAdjustment = item.asIeFeeAdjustment;
      this.AsReimbursement = item.asReimbursement;
      this.ReimbursementCurrencySymbol = item.reimbursementCurrencySymbol;
      this.AsTravel = item.asTravel;
      this.AsGaming = item.asGaming;
      this.AsMisc = item.asMisc;
      this.AsLdvname = item.asLdvname;
      this.AsFieldworkFee = item.asFieldworkFee;
      this.AsEvname = item.asEvname;
      this.LgsDesc = item.lgsDesc;
      this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
      this.CuCountry = item.cuCountry;
      // this.AsFeeWithSymbol = stringHelper.getValueWithSymbol('', item.asRcysymbol, item.asFee);
      this.AsEvaluatorCompletedDateFormatted = dateTimeHelper.toYYYYsMMsDD(item.asEvaluatorCompletedDate, "-");
      // this.AsFeeAdditWithSymbol = "";
      this.AsReimbursementWithSymbol = stringHelper.getValueWithSymbol("", item.asRcysymbol, item.asReimbursement);
      this.AsTravelWithSymbol = stringHelper.getValueWithSymbol("", item.asRcysymbol, item.asTravel);
      this.AsGamingWithSymbol = stringHelper.getValueWithSymbol("", item.asRcysymbol, item.asGaming);
      this.AsMiscWithSymbol = stringHelper.getValueWithSymbol("", item.asRcysymbol, item.asMisc);
      this.AsFieldworkFeeWithSymbol = stringHelper.getValueWithSymbol("", item.asRcysymbol, item.asFieldworkFee);
      this.AsUninvoiceable = item.asUninvoiceable ? "True" : "False";
      this.FeeTotal = stringHelper.getFeeTotal(item.asRcysymbol, [item.asFee]);
      this.ReimbTotal = stringHelper.getFeeTotal(item.asRcysymbol, [item.asReimbursement, item.asTravel, item.asGaming, item.asMisc]);
      this.AsCfname = item.asCfname;
      this.AsCfid = item.asCfid;
      this.Selected = false;
    }
  }

  static NameOfTheIdField() {
    return "AsId";
  }
  static nameOfTheItemDetailList() {
    return "Ready for Invoicing";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path="assignments"
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: "AsBillClient", value: "" },
          { key: "AsPayEvaluator", value: "" },
          { key: "AsSassieAsgnId", value: item.AsSassieAsgnId },
        ]}
      />
    );
  }
  static getIsActiveCellContent(item) {
    return (
      <div className="pointer">
        {
          <FigmaBadge
            Active={item}
            ActiveText="Yes"
            InactiveText="No"
            width={50}
          />
        }
      </div>
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: UninvoiceableAssignmentItem.getSelectedCellHeader,
        orderById: "",
        data: UninvoiceableAssignmentItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: "project_uninvoiceableassignmentselect",
      },
      { label: "Apollo Id", orderById: "AsSassieAsgnId", data: UninvoiceableAssignmentItem.idFunction },
      { label: "Location", orderById: "CuName", data: "CuName", minWidth: 250 },
      { label: "Client Fee Total", orderById: "FeeTotal", data: "FeeTotal", minWidth: 90 },
      { label: "Reimb. Total", orderById: "ReimbTotal", data: "ReimbTotal", minWidth: 80 },
      { label: "FW Office", orderById: "AsLdvname", data: "AsLdvname" },
      { label: "FW Fee", orderById: "AsFieldworkFeeWithSymbol", data: "AsFieldworkFeeWithSymbol", minWidth: 80 },
      { label: "Evaluator", orderById: "AsEvname", data: "AsEvname" },
      { label: "Status", orderById: "LgsDesc", data: "LgsDesc", minWidth: 70 },
      { label: "Completed On", orderById: "AsEvaluatorCompletedDateFormatted", data: "AsEvaluatorCompletedDateFormatted", minWidth: 90 },
      { label: "Country", orderById: "CuCountry", data: "CuCountry", minWidth: 55 },
      { label: "Uninv.", orderById: "AsUninvoiceable", data: (item) => UninvoiceableAssignmentItem.getIsActiveCellContent(item.AsUninvoiceable), minWidth: 55 },
    ];
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type="checkbox"
          checked={UninvoiceableAssignmentItem.selectedStatus()}
          onChange={(e) => {
            UninvoiceableAssignmentItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className="text-center">
        <input
          type="checkbox"
          checked={item.Selected}
          onChange={(e) => {
            UninvoiceableAssignmentItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
